module.exports = __webpack_public_path__ + "static/assets/0a23ebb872247265a464410d20b79fb7.svg";